import { Component, OnInit, HostBinding } from '@angular/core';
import { OverlayContainer} from '@angular/cdk/overlay';

@Component({
  selector: 'app-test-theme-switcher',
  templateUrl: './test-theme-switcher.component.html',
  styleUrls: ['./test-theme-switcher.component.scss']
})
export class TestThemeSwitcherComponent implements OnInit {
  @HostBinding('class') componentCssClass;


  constructor(private overlayContainer: OverlayContainer) { }
  currentTheme : number;

  ngOnInit() {

    this.currentTheme  = 1;
  }





}
